// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClearAutoOnboardedRecordsMutationVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ClearAutoOnboardedRecordsMutation = { __typename?: 'Mutation', updateHousehold: { __typename?: 'Household', id: string, newIndividualsAutomaticallyOnboardedAt?: Time | null } };

export const Operations = {
  Mutation: {
    ClearAutoOnboardedRecords: 'ClearAutoOnboardedRecords' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const ClearAutoOnboardedRecordsDocument = gql`
    mutation ClearAutoOnboardedRecords($householdId: ID!) {
  updateHousehold(
    id: $householdId
    input: {clearNewIndividualsAutomaticallyOnboardedAt: true}
  ) {
    id
    newIndividualsAutomaticallyOnboardedAt
  }
}
    `;
export type ClearAutoOnboardedRecordsMutationFn = Apollo.MutationFunction<ClearAutoOnboardedRecordsMutation, ClearAutoOnboardedRecordsMutationVariables>;

/**
 * __useClearAutoOnboardedRecordsMutation__
 *
 * To run a mutation, you first call `useClearAutoOnboardedRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAutoOnboardedRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAutoOnboardedRecordsMutation, { data, loading, error }] = useClearAutoOnboardedRecordsMutation({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useClearAutoOnboardedRecordsMutation(baseOptions?: Apollo.MutationHookOptions<ClearAutoOnboardedRecordsMutation, ClearAutoOnboardedRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAutoOnboardedRecordsMutation, ClearAutoOnboardedRecordsMutationVariables>(ClearAutoOnboardedRecordsDocument, options);
      }
export type ClearAutoOnboardedRecordsMutationHookResult = ReturnType<typeof useClearAutoOnboardedRecordsMutation>;
export type ClearAutoOnboardedRecordsMutationResult = Apollo.MutationResult<ClearAutoOnboardedRecordsMutation>;
export type ClearAutoOnboardedRecordsMutationOptions = Apollo.BaseMutationOptions<ClearAutoOnboardedRecordsMutation, ClearAutoOnboardedRecordsMutationVariables>;